import { render } from "./MsisdnDetails.vue?vue&type=template&id=2dac824c"
import script from "./MsisdnDetails.vue?vue&type=script&lang=js"
export * from "./MsisdnDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__